import { useEffect } from 'react';

const DetailsToggle = ({
  isComplete,
  isConverting,
  isDetailsOpen,
  setIsDetailsOpen,
}) => {
  useEffect(() => {
    if (isComplete) {
      setIsDetailsOpen(false);
    }
  }, [isComplete, setIsDetailsOpen]);

  useEffect(() => {
    if (!isComplete && !isConverting) {
      setIsDetailsOpen(true);
    }
  }, [isComplete, isConverting, setIsDetailsOpen]);

  if (!isComplete) return null;

  return (
    <div className="mb-3">
      <button
        type="button"
        aria-expanded={isDetailsOpen}
        onClick={() => setIsDetailsOpen((value) => !value)}
        className="btn btn-link p-0 d-flex align-items-center gap-2 text-decoration-none text-accent"
      >
        <span aria-hidden="true">{isDetailsOpen ? '▾' : '▸'}</span>
        <span className="fw-semibold">Details</span>
      </button>
    </div>
  );
};

export default DetailsToggle;
